export const MAPBOX_ACCESS_TOKEN = 'pk.eyJ1IjoiYm91YnNvbiIsImEiOiJjbTY5Y3Zkc2QwN2lrMmpzaGp5c2RlcngyIn0.gPzN_xXjA0fHABHXeOXHVQ';

export const NIGER_BOUNDS = [
  [0.16, 11.69],  // Sud-ouest
  [15.995, 23.525]  // Nord-est
];

export const DEFAULT_CENTER = [8.0817, 17.8739];

export const DEFAULT_ZOOM_LEVELS = {
  xs: 3.8,  // <= 375px
  sm: 4.0,  // <= 640px
  md: 4.3,  // <= 768px
  lg: 5.0,  // <= 1024px
  xl: 5.2   // > 1024px
};

export const MAP_STYLES = {
  SATELLITE: 'satellite-streets-v12',
  STREETS: 'streets-v12',
  LIGHT: 'light-v11',
  DARK: 'dark-v11',
  OUTDOORS: 'outdoors-v12'
};

export const CLUSTER_COLORS = {
  LOW: '#51bbd6',     // < 100 points
  MEDIUM: '#f1f075',  // 100-750 points
  HIGH: '#f28cb1'     // > 750 points
};

export const CLUSTER_SIZES = {
  LOW: 20,    // < 100 points
  MEDIUM: 30, // 100-750 points
  HIGH: 40    // > 750 points
};

export const POINT_STYLE = {
  COLOR: '#11b4da',
  RADIUS: 8,
  STROKE_WIDTH: 1,
  STROKE_COLOR: '#fff'
};

export const ROUTE_STYLE = {
  COLOR: '#3887be',
  WIDTH: 5,
  OPACITY: 0.75
};

export const MAP_PADDING = {
  MOBILE: {
    top: 50,
    bottom: 50,
    left: 20,
    right: 20
  },
  DESKTOP: {
    top: 100,
    bottom: 100,
    left: 50,
    right: 50
  }
};

export const ANIMATION_DURATION = 1000;

export const GEOCODER_OPTIONS = {
  placeholder: 'Rechercher un lieu...',
  countries: 'ne',
  language: 'fr',
  types: ['place', 'address', 'poi']
};

export const ERROR_MESSAGES = {
  OUTSIDE_BOUNDS: 'Cette localisation est en dehors du Niger',
  GEOLOCATION_ERROR: 'Impossible d\'obtenir votre position',
  ROUTE_ERROR: 'Impossible de calculer l\'itinéraire',
  SEARCH_ERROR: 'Erreur lors de la recherche'
};

export const CSS_CLASSES = {
  CUSTOM_POPUP: 'custom-popup',
  MOBILE_POPUP: 'mobile-popup',
  CUSTOM_MARKER: 'custom-marker'
};

export const BREAKPOINTS = {
  xs: 375,
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280
};

export const MAP_CONFIG = {
  minZoom: 5,
  maxZoom: 16,
  dragRotate: false,
  touchZoomRotate: false,
  dragPan: true,
  boxZoom: true,
  keyboard: true,
  doubleClickZoom: true,
  scrollZoom: true,
  pitchWithRotate: false,
  bearing: 0,
  pitch: 0
};